import { MapView } from "../../global/MapView";
import { Box } from "@mui/material";
import React from "react";

const FullMapView = ({ compInfo }) => {
  console.log(compInfo);
  if (compInfo.state || compInfo) {
    return (
      <Box width={"100%"} height={"100%"}>
        <MapView
          containerElement={
            <div
              style={{
                height: "85vh",
                width: compInfo.width, //width
              }}
            />
          }
          long={
            compInfo.location && compInfo.location.longitude
              ? compInfo.location.longitude
              : compInfo.state
              ? compInfo.state.fields.location.longitude
              : ""
          }
          lat={
            compInfo.location && compInfo.location.latitude
              ? compInfo.location.latitude
              : compInfo.state
              ? compInfo.state.fields.location.latitude
              : ""
          }
          accuracy={
            compInfo.location && compInfo.location.accuracy
              ? compInfo.location.accuracy
              : compInfo.state
              ? compInfo.state.fields.location.accuracy
              : ""
          }
          name={
            compInfo.state && compInfo.state.data.name
              ? compInfo.state.data.name
              : "No Name"
          }
          id={
            compInfo.state && compInfo.state.data.id
              ? compInfo.state.data.id
              : null
          }
          defaultZoom={1}
        />
      </Box>
    );
  } else {
    return (
      <Box width={"100%"} height={"100%"}>
        <div
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          Location Details Not Found
        </div>
      </Box>
    );
  }
};

export default FullMapView;
